import React, { Fragment } from 'react';

// Import all route modules
import authRoutes from './authRoutes';
import productRoutes from './productRoutes';
import pageRoutes from './pageRoutes';
import dashboardRoutes from './dashboardRoutes';
import examRoutes from './examRoutes';
import adminRoutes from './adminRoutes';
import groupRoutes from './groupRoutes';
import videoRoutes from './videoRoutes';
import redirectRoutes from './redirectRoutes';
import paymentRoutes from './paymentRoutes';

// Combine all routes into a single array
const allRoutes = [
  ...authRoutes,
  ...productRoutes,
  ...pageRoutes,
  ...dashboardRoutes,
  ...examRoutes,
  ...adminRoutes,
  ...groupRoutes,
  ...videoRoutes,
  ...redirectRoutes,
  ...paymentRoutes
];

export default allRoutes; 